import { render, staticRenderFns } from "./PriceImportItem.vue?vue&type=template&id=8649b804&scoped=true&"
import script from "./PriceImportItem.vue?vue&type=script&lang=js&"
export * from "./PriceImportItem.vue?vue&type=script&lang=js&"
import style0 from "./PriceImportItem.vue?vue&type=style&index=0&id=8649b804&lang=scss&scoped=true&"
import style1 from "./PriceImportItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8649b804",
  null
  
)

export default component.exports